module.exports = __webpack_public_path__ + "static/PlutoSansMedium-3306c21305c6e1b7c45f997645b934e8.woff";